import urlTool from '@/tools/url';
import fetchJQueryAdapter from '@/tools/fetchJQueryAdapter';

/**
 * @memberof module:ajaxAPI/favorites
 * @alias get
 *
 * @description
 * Получение списка избранного
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.favorites.get()
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function(id) {
  const lang = urlTool.getKeyValue('lang') || '';
  const request_url = `${window.location.origin}/front_api/favorites.json`;

  let path = new URL(request_url);

  if (lang) {
    path.searchParams.set('lang', lang);
  }

  return fetchJQueryAdapter(path);
};
